import Vue from 'vue'
import Vuex from 'vuex'

import getters from './getters'
import mutations from './mutations'
import actions from './actions'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: {
      token: null,
      playerResultId: null,
      details: null
    },
    assessmentId: null,
    timeUp: null,
    gameplay: null,
    started: null,
    windowWidth: 0,
    langKey: null,
    assessment: null,
    answers: [],
    barKey: 0
  },
  getters,
  mutations,
  actions
})
